
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';

const GoogleCalendarSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  
  useEffect(() => {
    toast({
      title: "Google Calendar Connected",
      description: "Your Google Calendar has been successfully connected.",
    });
  }, [toast]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-green-100">
          <Check className="h-10 w-10 text-green-600" />
        </div>
        
        <h2 className="mt-6 text-2xl font-bold text-gray-900">Google Calendar Connected!</h2>
        
        <p className="mt-3 text-gray-600">
          Your Google Calendar has been successfully connected to the platform.
          You can now receive and manage appointment bookings through your calendar.
        </p>
        
        <div className="mt-8 flex flex-col space-y-4">
          <Button 
            className="w-full"
            onClick={() => navigate('/master-license/settings')}
          >
            <Calendar className="mr-2 h-4 w-4" />
            Go to Calendar Settings
          </Button>
          
          <Button 
            variant="outline"
            className="w-full"
            onClick={() => navigate('/')}
          >
            Return to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GoogleCalendarSuccess;
